import { Injectable } from "@angular/core";
import { AppSettings } from "../app.settings";

@Injectable()
export class LocalstorageService {
	getItem(key: string): any {
		var keyName = AppSettings.APP_NAME + "_" + key;
		var item = localStorage.getItem(keyName);
		if (item) {
			var value = JSON.parse(item);
			return value;
		}
	}

	setItem(key: string, item) {
		var keyName = AppSettings.APP_NAME + "_" + key;
		var data = null;
		if (item) {
			data = JSON.stringify(item);
			localStorage.setItem(keyName, data);
		} else {
			localStorage.removeItem(keyName);
		}
	}
}
